import { InjectionToken } from '@angular/core'
import { InMemoryCache } from '@apollo/client/core'

export const APOLLO_CACHE = new InjectionToken<InMemoryCache>('apollo-cache')
